<template>
    <div class="menu-left">
        <div>
            <div @mouseover="hover('notifications')">
                <div>{{ total }}</div>
                <i class="fa-solid fa-bell"></i>
            </div>
            <img :src="$store.state.user.avatar" alt="" @mouseover="hover('user')">
        </div>
        <div class="menu-notifications" ref="notifications" @mouseleave="removeHover('notifications')">
            <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="400" v-if="solicitudes.length > 0">
                <div v-for="(item, index) in solicitudes" :key="index" @click="goTo(item.type)">
                    <div>
                        <img :src="item.photo" alt="">
                        <label for="">Solicitud de: {{ item.name }}</label>
                    </div>
                    <span>Tipo: {{ item.type }}</span>
                </div>
            </ul>
            <div v-else>
                No hay notificaciones para mostrar
            </div>
        </div>
        <div class="menu-user" ref="user" @mouseleave="removeHover('user')">
                <div>
                    <label @click="$router.push('/perfil')">Ver perfil</label>
                    <label for="" @click="logOut()">Cerrar Sesion</label>
                </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'

export default {
    name: 'menu-user',
    data() {
        return {
            solicitudes: [],
            limit: 20,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false
        }
    },
    computed: {
        total: {
            get() {
                return this.solicitudes.length
            }
        }
    },
    methods: {
        logOut() {
            this.$store.commit('logOut')
            this.$router.push('/login')
        },
        goTo(item) {
            if (item === 'Documento') {
                this.$router.push('/solicitudes/documentos')
            } else if (item === 'Producto') {
                this.$router.push('/solicitudes/productos')
            } else if (item === 'Imagen de Perfil') {
                this.$router.push('/solicitudes/picture')
            }
        },
        loadMore() {
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.solicitudes.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getAllSolicitudes('')
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        },
        getAllSolicitudes(reCall = false) {
            API.getAllSolicitudes(this.limit, this.offset)
                .then((res) => {
                    if (this.solicitudes.length === res.length && reCall) {
                        setTimeout(() => { this.getAllSolicitudes(true) }, 5000)
                    } else if (this.solicitudes.length !== res.length && reCall) {
                        this.solicitudes = []
                        res.map(item => { this.solicitudes.push(item) })
                        setTimeout(() => { this.getAllSolicitudes(true) }, 5000)
                    } else if (!reCall) {
                        this.limit = 20
                        this.offset = 0
                        this.busy = false
                        this.listEnd = false
                        this.itemFlag = false
                        this.solicitudes = []
                        res.map(item => { this.solicitudes.push(item) })
                        setTimeout(() => { this.getAllSolicitudes(false) }, 5000)
                    }
                })
        },
        hover(element) {
            if (element === 'notifications') {
                this.$refs.notifications.style.display = 'block'
                this.$refs.user.style.display = 'none'
            } else {
                this.$refs.user.style.display = 'block'
                this.$refs.notifications.style.display = 'none'
            }
        },
        removeHover(element) {
            if (element === 'notifications') {
                this.$refs.notifications.style.display = 'none'
            } else {
                this.$refs.user.style.display = 'none'
            }
        }
    },
    mounted() {
        this.getAllSolicitudes()
    }
}
</script>

<style scoped>
    .menu-left {
        width: 100%;
        height: 10vh;
        background-color: #2b2926;
        position: relative;
        z-index: 9;
    }
    .menu-left > div {
        position: absolute;
        right: 100px;
        top: 50%;
        transform: translateY(-50%);
        color: #fff;
        display: flex;
    }
    .menu-left > div > div {
        position: relative;
    }
    .menu-left > div > div > svg {
        width: 35px;
        height: 35px;
        margin: 15px;
        cursor: pointer;
    }
    .menu-left > div > div > div {
        position: absolute;
        right: 15px;
        background-color: red;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        text-align: center;
    }
    .menu-left > div > img {
        width: 50px;
        height: 50px;
        margin: 10px;
        object-fit: cover;
        border-radius: 50%;
        cursor: pointer;
    }

    .menu-left > .menu-notifications {
        width: 350px;
        height: 500px;
        background-color: #2b2926;
        position: absolute;
        top: 350px;
        right: 50px;
        display: none;
        overflow: auto;
        border-radius: 20px;
    }
    .menu-left > .menu-notifications > div {
        position: absolute;
        margin: auto;
        align-items: center;
        justify-items: center;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        border-style: solid;
    }
    .menu-left > .menu-user {
        width: 250px;
        height: 150px;
        background-color: #2b2926;
        position: absolute;
        top: 175px;
        right: 30px;
        display: none;
        text-align: center;
        padding: 20px;
        border-radius: 20px;
    }
    .menu-left > .menu-user > div > label{
        border-style: solid;
        cursor: pointer;
        padding: 10px;
        width: 100%;
    }
    .menu-left > .menu-user > div > label:hover {
        background-color: #e0b059;
    }
    .menu-left > .menu-notifications > ul {
        padding: 20px;
        overflow: auto;
        cursor: pointer;
    }
    .menu-left > .menu-notifications > ul > div{
        border-style: solid;
        padding: 10px;
        display: grid;
        cursor: pointer;
    }
    .menu-left > .menu-notifications > ul > div > div >img {
        width: 50px;
        height: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Menu/Menu.vue